import React, { useContext, useEffect, useState } from 'react'
import { Form } from 'react-router-dom'
import Application from "../../../StateContext/Application"
import { usePDF } from 'react-to-pdf'
import { CSVLink } from 'react-csv'
// import { Excel11, failed, PDF11, pending, success, Winnericon32 } from '../../../../../public/LoginImages/importimages'
import { apiurl } from '../../../../../path'
import { BarChart,Cell, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import iconSrc from "../../../../../public/LoginImages/Dashboard32.png"
import TotalEcsGenerated from "../../../../../public/LoginImages/Total-ECS-Generated.png";
import EcsAwaited from "../../../../../public/LoginImages/ECS-AWAITED.png";
import EcsCompleted from "../../../../../public/LoginImages/ECS-Completed.png";
import EcsFailed from "../../../../../public/LoginImages/ECS-Failed.png";
import EcsReturn from "../../../../../public/LoginImages/ECS-Return.png";
const ECSReport = () => {
    const statecalls = useContext(Application)
    const { FetchECSFiles, FetchECSReport, FetchECSDashboardReport } = statecalls;
    const [fileName, SetFileName] = useState([])
    const [ecsdata, SetECSData] = useState([])
    const [ecsdashboarddata, SetECSDashboardData] = useState({
        totalGenerated: { count: 0, amount: 0 },
        awaited: { count: 0, amount: 0 },
        completed: { count: 0, amount: 0 },
        return: { count: 0, amount: 0 },
        failed: { count: 0, amount: 0 },
    });

    const [searchFileData, SetSearchFileData] = useState('')
    const { toPDF, targetRef } = usePDF({ filename: 'page.pdf' });
    const [CSVDATA, SetCSVDATA] = useState([])
    const [summary, setSummary] = useState({ file: "", count: 0, amount: 0 });

    const [isPrinting, setIsPrinting] = useState(false);
    const [isPdfExporting, setIsPdfExporting] = useState(false);

    useEffect(() => {
        const beforePrint = () => setIsPrinting(true);
        const afterPrint = () => setIsPrinting(false);

        window.addEventListener('beforeprint', beforePrint);
        window.addEventListener('afterprint', afterPrint);

        return () => {
            window.removeEventListener('beforeprint', beforePrint);
            window.removeEventListener('afterprint', afterPrint);
        };
    }, []);

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(ecsdata.length / itemsPerPage);
    const paginatedData = ecsdata.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageChange = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    let a = localStorage.getItem("FullName")
    console.log("Token in ECS Report:", a);

    useEffect(() => {
     
            GetAuctions();
    }, [])
    async function GetAuctions(token) {
        try {
            let data = await FetchECSFiles(token);
            console.log("Visible ECS Files:", data);

            SetFileName(Array.isArray(data) ? data : []);
        } catch (error) {
            console.log(error);
            SetFileName([]);
        }
    }

    async function GetAllDashboardReport() {
        try {
            const data = await FetchECSDashboardReport();
            if (data && data.length > 0) {
                console.log("ECSDashboard Data:", data);

                const totalGeneratedCount = data.length;
                const totalGeneratedAmount = data.reduce(
                    (sum, d) => sum + Number(d.refund_amount || 0),
                    0
                );

                const awaitedData = data.filter((d) => d.status == "Pending");
                console.log("Awaited Data:", awaitedData);

                const completedData = data.filter(
                    (d) => d.status == "Successful/Paid"
                );
                console.log("Completed Data:", completedData);

                const returnData = data.filter(
                    (d) => d.status == "Return"
                );

                const failedData = data.filter(
                    (d) => d.status !== "Pending" && d.status !== "Successful/Paid" && d.status !== "Return"
                );

                SetECSDashboardData({
                    totalGenerated: {
                        count: totalGeneratedCount,
                        amount: totalGeneratedAmount,
                    },
                    awaited: {
                        count: awaitedData.length,
                        amount: awaitedData.reduce(
                            (sum, d) => sum + Number(d.refund_amount || 0),
                            0
                        ),
                    },
                    completed: {
                        count: completedData.length,
                        amount: completedData.reduce(
                            (sum, d) => sum + Number(d.refund_amount || 0),
                            0
                        ),
                    },
                    return: {
                        count: returnData.length,
                        amount: returnData.reduce(
                            (sum, d) => sum + Number(d.refund_amount || 0),
                            0
                        ),
                    },
                    failed: {
                        count: failedData.length,
                        amount: failedData.reduce(
                            (sum, d) => sum + Number(d.refund_amount || 0),
                            0
                        ),
                    },
                });
            }
        } catch (err) {
            console.error("Dashboard fetch error", err);
        }
    }

    // Prepare chart data
    const chartData = [
        { name: "Generated", Count: ecsdashboarddata.totalGenerated.count },
        { name: "Awaited", Count: ecsdashboarddata.awaited.count },
        { name: "Completed", Count: ecsdashboarddata.completed.count },
        { name: "Return", Count: ecsdashboarddata.return.count },
        { name: "Failed", Count: ecsdashboarddata.failed.count },
    ];


    useEffect(() => {
        GetAllDashboardReport()
    }, [])

    async function GetECSReport() {
        try {
            if (!searchFileData) {
                alert("Please Select File Name")
            } else {
                let data = await FetchECSReport(searchFileData)
                console.log("data", data);
                SetECSData(data)

                if (data && data.length > 0) {
                    const totalAmount = data.reduce((sum, item) => sum + Number(item.refund_amount || 0), 0);
                    setSummary({
                        file: searchFileData,
                        count: data.length,
                        amount: totalAmount
                    });
                } else {
                    setSummary({ file: searchFileData, count: 0, amount: 0 });
                }
            }
        } catch (error) {
            console.log(error);
        }
    }


    function onSavefile() {
        if (ecsdata.length > 0) {
            const headers = Object.keys(ecsdata[0]);
            const csvData = ecsdata.map(item => headers.map(key => item[key]));
            const finalcsv = [headers, ...csvData];
            SetCSVDATA(finalcsv);
        }
    }

    const handleDownloadPDF = async () => {
        try {
            setIsPdfExporting(true);
            await new Promise((resolve) => setTimeout(resolve, 100));
            await toPDF();
        } finally {
            setIsPdfExporting(false);
        }
    };

    const formatINR = (val) => {
    if (val === "" || val === null || val === undefined) return "";
 
    const number = Number(val);
    if (isNaN(number)) return "";
 
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
    }).format(number);
  };

    // return (
    //     <>
    //         <div
    //             style={{
    //                 backgroundColor: "#f4f8fc",
    //                 maxHeight: "90vh",
    //                 overflowY: "auto",
    //                 msOverflowStyle: "none",       // IE & Edge
    //                 scrollbarWidth: "none",
    //                 padding: '20px',        // Firefox
    //             }}
    //             className="no-scrollbar"
    //         >
    //             <div className="dashboard-header-name">
    //                 <img
    //                     src={iconSrc}
    //                     alt={"Dashboard Icon"}
    //                     className="dashboard-menu-icon"
    //                 />
    //                 <h1 className="dashboard-title">ECS Dashboard</h1>
    //             </div>

    //             <div style={{ padding: "20px", backgroundColor: "#f5f9fc" }}>
    //                 <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "20px" }} >
    //                     {/* Total Generated */}
    //                     <div style={{ background: "linear-gradient(to right, #3d8696, #2370a0)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }} >
    //                         <h4>Total ECS Generated</h4>
    //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.totalGenerated.count}</p>
    //                         <p>₹ {ecsdashboarddata.totalGenerated.amount}</p>
    //                     </div>
    //                     {/* Awaited */}
    //                     <div style={{ background: "linear-gradient(to right, #f7b733, #fc4a1a)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
    //                         <h4>ECS Awaited</h4>
    //                         <p style={{ fontSize: "24px", fontWeight: "600" }}>{ecsdashboarddata.awaited.count}</p>
    //                         <p>₹ {ecsdashboarddata.awaited.amount}</p>
    //                     </div>
    //                     {/* Completed */}
    //                     <div style={{ background: "linear-gradient(to right, #11998e, #38ef7d)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
    //                         <h4>ECS Completed</h4>
    //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.completed.count}</p>
    //                         <p>₹ {ecsdashboarddata.completed.amount}</p>
    //                     </div>
    //                     {/* Return */}
    //                     <div style={{ background: "linear-gradient(to right, #8185ffff, #31009cff)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
    //                         <h4>ECS Return</h4>
    //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.return.count}</p>
    //                         <p>₹ {ecsdashboarddata.return.amount}</p>
    //                     </div>
    //                     {/* Failed */}
    //                     <div style={{ background: "linear-gradient(to right, #e52d27, #b31217)", color: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
    //                         <h4>ECS Failed</h4>
    //                         <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.failed.count}</p>
    //                         <p>₹ {ecsdashboarddata.failed.amount}</p>
    //                     </div>
    //                 </div>
    //             </div>

    //             <div style={{ padding: '2rem' }}>
    //                 <div style={{ display: "grid", border: "2px solid red", borderRadius: "10px", border: "none", padding: "20px", backgroundColor: 'white' }}>
    //                     <div style={{ display: 'grid' }}>
    //                         <Form>
    //                             <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: '20px', alignItems: 'center' }}>
    //                                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
    //                                     <label className='form-label mx-3' style={{ fontWeight: '600', display: 'flex' }}>File Name</label>
    //                                     <select className='form-control' onChange={(e) => { SetSearchFileData(e.currentTarget.value) }} style={{ width: "25rem", fontWeight: '600' }}>
    //                                         <option selected disabled>Select File</option>
    //                                         {
    //                                             Array.isArray(fileName) && fileName.map((e, index) => (
    //                                                 <option key={index} value={e.FileName}>
    //                                                     {e.FileName}
    //                                                 </option>
    //                                             ))
    //                                         }

    //                                     </select>
    //                                 </div>
    //                                 <div>
    //                                     <button className="pending-button" type="button" onClick={() => GetECSReport()} style={{ display: 'flex', alignItems: 'center', border: '2px solid #0071bc', borderRadius: '5px', width: '6rem', height: '2.3rem', fontSize: '14px', color: '#0071bc', backgroundColor: 'white', cursor: 'pointer' }}>
    //                                         {/* <img src="" className="mx-1" alt="Search" />  */}
    //                                         Search</button>
    //                                 </div>

    //                             </div>
    //                         </Form>
    //                     </div>
    //                 </div>
    //             </div>

    //             <div style={{ padding: "20px", overflow: "auto", backgroundColor: '#f5f9fc' }}>
    //                 <div style={{ display: "grid", borderRadius: "20px", padding: "20px", backgroundColor: 'white' }}>
    //                     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
    //                         <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
    //                             <h5 style={{ paddingTop: '10px' }}>Payment Data</h5>
    //                         </div>
    //                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', paddingBottom: '10px' }}>
    //                             {
    //                                 ecsdata.length > 0 ? (
    //                                     <>
    //                                         <button onClick={handleDownloadPDF} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', cursor: 'pointer' }} ><img src="" style={{ width: '14px' }} /> Download PDF</button>
    //                                         <CSVLink data={CSVDATA} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', textDecoration: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }} onClick={onSavefile}><img src="" style={{ width: '14px' }} /> Download Excel</CSVLink>
    //                                     </>
    //                                 ) : (
    //                                     <>
    //                                         <div type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', fontSize: '14px', cursor: 'pointer' }} disabled><img src="" style={{ width: '14px' }} /> Download PDF</div>
    //                                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '8rem', height: '2rem', border: '2px solid darkgray', backgroundColor: '#f2f2f2', borderRadius: '20px', gap: '3px', color: 'black', fontSize: '14px', cursor: 'pointer' }} disabled><img src="" style={{ width: '14px' }} /> Download Excel
    //                                         </div>
    //                                     </>
    //                                 )
    //                             }
    //                         </div>
    //                     </div>


    //                     {/* <div className="table-responsive" style={{ width: '96%', margin: '0 auto' }} ref={targetRef}>
    //                         <table className="project-table" style={{ backgroundColor: '#e8f7f3', width: '100%', borderCollapse: "collapse" }} ref={targetRef}>
    //                             <thead>
    //                                 <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
    //                                     <th>File Name</th>
    //                                     <th>Total Count</th>
    //                                     <th>Total Amount</th>
    //                                 </tr>
    //                                 {summary.file && (
    //                                     <tr style={{ backgroundColor: "#c8e5fc", fontWeight: "600" }}>
    //                                         <td><a href={`${apiurl}/UploadedBillsFiles/${summary.file}`} target='_blank'>{summary.file}</a></td>
    //                                         <td>{summary.count}</td>
    //                                         <td>{summary.amount}</td>
    //                                     </tr>
    //                                 )}

    //                                 <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
    //                                     <th>Sr.No.</th>
    //                                     <th>Unique_ID</th>
    //                                     <th>Account_HolderName</th>
    //                                     <th>Account_Number</th>
    //                                     <th>IFSC_CODE</th>
    //                                     <th>Refund_amount</th>
    //                                     <th>Payment_Mode</th>
    //                                     <th>Status</th>
    //                                     <th>StatusDesc</th>
    //                                     <th>Date</th>
    //                                 </tr>
    //                             </thead>

    //                             <tbody>
    //                                 {paginatedData && paginatedData.length > 0 ? (
    //                                     paginatedData.map((e, index) => (
    //                                         <tr key={index}>
    //                                             <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
    //                                             <td>{e.Unique_ID}</td>
    //                                             <td>{e.Account_HolderName}</td>
    //                                             <td>{e.AccNumber}</td>
    //                                             <td>{e.IFSC_CODE}</td>
    //                                             <td>{e.refund_amount}</td>
    //                                             <td>{e.Payment_Mode}</td>
    //                                             <td>{e.status}</td>
    //                                             <td>{e.statusDesc}</td>
    //                                             <td>{e.Date?.split('.')[0].replace('T', ' ')}</td>
    //                                         </tr>
    //                                     ))
    //                                 ) : (
    //                                     <tr>
    //                                         <td colSpan="10" style={{ textAlign: 'center' }}>No data available in table</td>
    //                                     </tr>
    //                                 )}
    //                             </tbody>
    //                         </table>



    //                         <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#c8e5fc', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
    //                             <div><p style={{ margin: '0px' }}>Showing {paginatedData.length} of {ecsdata.length} entries</p></div>
    //                             <div >
    //                                 <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}> &laquo; </button>
                                   
    //                                 <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &lt; </button>
    //                                 {Array.from({ length: totalPages }, (_, index) => (
    //                                     <button key={index} onClick={() => handlePageChange(index + 1)} style={{ background: 'linear-gradient(to Right, #20ae8a, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: currentPage === index + 1 ? 'white' : 'black', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{index + 1}</button>
    //                                 ))}
    //                                 <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &gt; </button>
    //                                 <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &raquo;</button>
    //                             </div>
    //                         </div>
    //                     </div> */}

    //                     <div className="col-12 tableDesign" style={{ overflowX: "auto" }} ref={targetRef}>
    //                         <table style={{ width: "100%", borderCollapse: "collapse" }} >
    //                             <thead style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', backgroundImage: "none" }}>
    //                                 <tr style={{ color: "white", border: "none", height: "3rem", }}>
    //                                     <th>File Name</th>
    //                                     <th>Total Count</th>
    //                                     <th>Total Amount</th>
    //                                 </tr>
    //                             </thead>
    //                             <tbody>
    //                                 {summary.file && (
    //                                     <tr style={{ backgroundColor: "#c8e5fc", fontWeight: "600", padding: "8px" }}>
    //                                         <td style={{ padding: "8px" }}>
    //                                             <a href={`${apiurl}/UploadedBillsFiles/${summary.file}`} target="_blank">
    //                                                 {summary.file}
    //                                             </a>
    //                                         </td>
    //                                         <td>{summary.count}</td>
    //                                         <td>{formatINR(summary.amount)}</td>
    //                                     </tr>
    //                                 )}
    //                             </tbody>
    //                         </table>

    //                         {/* ✅ Scrollable Detail Table */}
    //                         <div className="col-12 tableDesign" style={{ overflowX: "auto" }}>
    //                             <table style={{ width: "100%", borderCollapse: "collapse", overflowX: "auto" }}>
    //                                 <thead style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', backgroundImage: "none" }}>
    //                                     <tr style={{ color: "white", border: "none", height: "3rem", }}>
    //                                         <th style={{ minWidth: "70px" }}>Sr.No.</th>
    //                                         <th style={{ minWidth: "100px" }}>Unique ID</th>
    //                                         <th style={{ minWidth: "170px" }}>Account Holder Name</th>
    //                                         <th style={{ minWidth: "140px" }}>Account Number</th>
    //                                         <th style={{ minWidth: "120px" }}>IFSC CODE</th>
    //                                         <th style={{ minWidth: "110px" }}>Refund Amount</th>
    //                                         <th style={{ minWidth: "110px" }}> Payment Mode</th>
    //                                         <th style={{ minWidth: "100px" }}>Status</th>
    //                                         <th style={{ minWidth: "120px" }}>Status Desc</th>
    //                                         <th style={{ minWidth: "140px" }}>Date</th>
    //                                     </tr>
    //                                 </thead>

    //                                 <tbody>
    //                                     {(isPrinting || isPdfExporting ? ecsdata : paginatedData)?.length > 0 ? (
    //                                         (isPrinting || isPdfExporting ? ecsdata : paginatedData).map((e, index) => (
    //                                             <tr key={index} style={{ background: "white" }}>
    //                                                 <td>{isPrinting || isPdfExporting ? index + 1 : (currentPage - 1) * itemsPerPage + index + 1}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.Unique_ID}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.Account_HolderName}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.AccNumber}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.IFSC_CODE}</td>
    //                                                 <td style={{ padding: "8px" }}>{formatINR(e.refund_amount)}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.Payment_Mode}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.status}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.statusDesc}</td>
    //                                                 <td style={{ padding: "8px" }}>{e.Date?.split('.')[0].replace('T', ' ')}</td>
    //                                             </tr>
    //                                         ))
    //                                     ) : (
    //                                         <tr>
    //                                             <td colSpan="10" style={{ textAlign: 'center', background: "white", padding: "8px" }}>
    //                                                 No data available in table
    //                                             </td>
    //                                         </tr>
    //                                     )}
    //                                 </tbody>
    //                             </table>
    //                         </div>
    //                     </div>
    //                     {/* Pagination */}
    //                     <div style={{ display: 'flex', justifyContent: 'space-between', height: '3rem', alignItems: 'center' }}>
    //                         <div><p style={{ margin: '0px' }}>Showing {paginatedData.length} of {ecsdata.length} entries</p></div>
    //                         <div >
    //                             {/* First Page Button */}
    //                             <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}> &laquo; </button>
    //                             {/* Previous Button */}
    //                             <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &lt; </button>
    //                             {/* Page Buttons */}
    //                             {Array.from({ length: totalPages }, (_, index) => (
    //                                 <button key={index} onClick={() => handlePageChange(index + 1)} style={{ background: '#0B83C3', color: currentPage === index + 1 ? 'white' : 'black', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{index + 1}</button>
    //                             ))}
    //                             {/* Next Button */}
    //                             <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &gt; </button>
    //                             {/* Last Page Button */}
    //                             <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &raquo;</button>
    //                         </div>
    //                     </div> 
    //                 </div>
    //             </div>

    //             {/* Chart */}
    //             <div style={{ width: "100%", height: 400, backgroundColor: "white", padding: "20px", borderRadius: "12px", boxShadow: "0 4px 10px rgba(0,0,0,0.1)" }}>
    //                 <h3 style={{ textAlign: "center", marginBottom: "20px" }}>ECS Status Count</h3>
    //                 <ResponsiveContainer width="100%" height="100%">
    //                     <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
    //                         <CartesianGrid strokeDasharray="3 3" />
    //                         <XAxis dataKey="name" />
    //                         <YAxis />
    //                         <Tooltip />
    //                         <Legend />
    //                         <Bar dataKey="Count" fill="#8884d8" />
    //                     </BarChart>
    //                 </ResponsiveContainer>
    //             </div>

    //         </div>
    //     </>
    // )
      return (
            <>
                <div
                    style={{
                        backgroundColor: "#ffffff",
                        maxHeight: "90vh",
                        overflowY: "auto",
                        msOverflowStyle: "none",       // IE & Edge
                        scrollbarWidth: "none",
                        padding: '20px',        // Firefox
                    }}
                    className="no-scrollbar"
                >
                    <div className="dashboard-header-name">
                        <img
                            src={iconSrc}
                            alt={"Dashboard Icon"}
                            className="dashboard-menu-icon"
                        />
                        <h1 className="dashboard-title">ECS Dashboard</h1>
                    </div>
    
                    <div style={{ padding: "20px", backgroundColor: "#ffffff" }}>
                        <div  style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "18px",
            width: "100%"
        }}>
                            {/* Total Generated */}
                            <div  style={{
            backgroundColor: "#f4f8fc",
            border: "1px solid #4d9df5",
            borderRadius: "14px",
            padding: "14px 16px",
            minHeight: "108px",
            display: "flex",
            alignItems: "center",
            gap: "12px"
        }} >
             <div
            style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                backgroundColor: "#dceeff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
            }}
        >
            <img
                src={TotalEcsGenerated}
                alt="Generated"
                style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain"
                }}
            />
        </div>
     
     
            <div >
    
                                <h4 style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    margin: "0 0 4px 0",
                    color: "#111",
                    whiteSpace:"nowrap"
                }}
     >Total ECS Generated</h4>
                                <p  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    margin: "0 0 6px 0",
                    color: "#111"
                }}> {ecsdashboarddata.totalGenerated.count}</p>
                                <p  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    margin: "0",
                    color: "#111"
                }}>₹ {ecsdashboarddata.totalGenerated.amount}</p>
                            </div></div>
                            {/* Awaited */}
                            <div style={{
        backgroundColor: "#f8f7ff",
        border: "1px solid #8b82ff",
        color: "#111",
        padding: "14px 16px",
        borderRadius: "14px",
        minHeight: "108px",
        display: "flex",
        alignItems: "center",
        gap: "12px"
    }}>
       
        <div
            style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                backgroundColor: "#dceeff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
            }}
        >
            <img
                src={EcsAwaited}
                alt="Generated"
                style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain"
                }}
            />
        </div>
     
      <div>
                                <h4 style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    margin: "0 0 4px 0",
                    color: "#111",
                    whiteSpace:"nowrap"
                }}>ECS Awaited</h4>
                                <p  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    margin: "0 0 6px 0",
                    color: "#111"
                }}>{ecsdashboarddata.awaited.count}</p>
                                <p  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    margin: "0",
                    color: "#111"
                }}>₹ {ecsdashboarddata.awaited.amount}</p>
                            </div></div>
                            {/* Completed */}
                            <div  style={{
        backgroundColor: "#f1faf4",
        border: "1px solid #55b86a",
        color: "#111",
        padding: "14px 16px",
        borderRadius: "14px",
        minHeight: "108px",
        display: "flex",
        alignItems: "center",
        gap: "12px"
    }}
     >
        <div
            style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                backgroundColor: "#dceeff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
            }}
        >
            <img
                src={EcsCompleted}
                alt="Generated"
                style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain"
                }}
            />
        </div>
     
      <div>
                                <h4 style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    margin: "0 0 4px 0",
                    color: "#111",
                    whiteSpace:"nowrap"
                }}>ECS Completed</h4>
                                <p  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    margin: "0 0 6px 0",
                    color: "#111"
                }}> {ecsdashboarddata.completed.count}</p>
                                <p  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    margin: "0",
                    color: "#111"
                }}> ₹ {ecsdashboarddata.completed.amount}</p>
                            </div></div>
                            {/* Return */}
                            <div style={{
        backgroundColor: "#fff8f1",
        border: "1px solid #f0a04b",
        color: "#111",
        padding: "14px 16px",
        borderRadius: "14px",
        minHeight: "108px",
        display: "flex",
        alignItems: "center",
        gap: "12px"
    }}>
        <div
            style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                backgroundColor: "#dceeff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
            }}
        >
            <img
                src={EcsReturn}
                alt="Generated"
                style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain"
                }}
            />
        </div>
     
      <div>
                                <h4 style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    margin: "0 0 4px 0",
                    color: "#111",
                    whiteSpace:"nowrap"
                }}>ECS Return</h4>
                                <p  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    margin: "0 0 6px 0",
                    color: "#111"
                }}> {ecsdashboarddata.return.count}</p>
                                <p  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    margin: "0",
                    color: "#111"
                }}>₹ {ecsdashboarddata.return.amount}</p>
                            </div></div>
                            {/* Failed */}
                            <div   style={{
        backgroundColor: "#fff5f5",
        border: "1px solid #ef6b6b",
        color: "#111",
        padding: "14px 16px",
        borderRadius: "14px",
        minHeight: "108px",
        display: "flex",
        alignItems: "center",
        gap: "12px"
    }}
     >  <div
            style={{
                width: "42px",
                height: "42px",
                borderRadius: "12px",
                backgroundColor: "#dceeff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
            }}
        >
            <img
                src={EcsFailed}
                alt="Generated"
                style={{
                    width: "24px",
                    height: "24px",
                    objectFit: "contain"
                }}
            />
        </div>
     
     <div>
                                <h4 style={{
                    fontSize: "13px",
                    fontWeight: "500",
                    margin: "0 0 4px 0",
                    color: "#111",
                    whiteSpace:"nowrap"
                }}>ECS Failed</h4>
                                <p style={{ fontSize: "24px", fontWeight: "600" }}> {ecsdashboarddata.failed.count}</p>
                                <p  style={{
                    fontSize: "13px",
                    fontWeight: "700",
                    margin: "0",
                    color: "#111"
                }}>₹ {ecsdashboarddata.failed.amount}</p>
                            </div></div>
                        </div>
                    </div>
    
                    <div style={{ padding: '20px 0' }}>
                        <div  style={{
                backgroundColor: "#edf5fc",
                border:'1px solid #b6dcff',
                borderRadius: "12px",
                padding: "25px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
            }}>
                            <div style={{ display: 'grid' }}>
                                <Form>
                                    <div  style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "15px",
            flexWrap: "wrap"
        }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
                                            <label className='form-label mx-3' style={{ fontWeight: '600', display: 'flex' }}>File Name</label>
                                            <select className='form-control' onChange={(e) => { SetSearchFileData(e.currentTarget.value) }} style={{ width: "45rem", fontWeight: '600' }}>
                                                <option selected disabled>Select File</option>
                                                {
                                                    Array.isArray(fileName) && fileName.map((e, index) => (
                                                        <option key={index} value={e.FileName}>
                                                            {e.FileName}
                                                        </option>
                                                    ))
                                                }
    
                                            </select>
                                        </div>
                                        <div>
                                            <button className="pending-button" type="button" onClick={() => GetECSReport()} style={{
            width: "95px",
            height: "38px",
            border: "none",
            borderRadius: "6px",
            background: "linear-gradient(90deg, #087fc1, #0065a8)",
            color: "white",
            fontSize: "14px",
            fontWeight: "500",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.15)"
        }}
     >
                                                {/* <img src="" className="mx-1" alt="Search" />  */}
                   <img
    src="/Search-White-32.png"
    alt="img"
   style={{height:"18px", width:"18px"}}
  />
 
                                                Search</button>
                                        </div>
    
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
    
                    <div style={{ padding: "20px 0", overflow: "auto", backgroundColor: '#ffffff' }}>
                        <div style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "20px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
            }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
                                    <h5  style={{
            margin: "0",
            fontSize: "16px",
            fontWeight: "600",
            color: "#333"
        }}>Payment Data</h5>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '10px', paddingBottom: '10px' }}>
                                    {
                                        ecsdata.length > 0 ? (
                                            <>
                                                <button onClick={handleDownloadPDF} type='button'  style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "145px",
            height: "36px",
            border: "1px solid #ff5757",
            backgroundColor: "#fff",
            borderRadius: "20px",
            gap: "7px",
            color: "#ff5757",
            fontSize: "13px",
            fontWeight: "500",
            cursor: "pointer"
        }}  > <img
    src="/Download-PDF-32.png"
    alt="img"
   style={{height:"20px", width:"20px"}}
  /> Download PDF</button>
                                                <CSVLink data={CSVDATA} style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "145px",
            height: "36px",
            border: "1px solid #24945c",
            backgroundColor: "#fff",
            borderRadius: "20px",
            gap: "7px",
            color: "#16834d",
            textDecoration: "none",
            fontSize: "13px",
            fontWeight: "500",
            cursor: "pointer"
        }} onClick={onSavefile}><img
    src="/Download-Excel-32.png"
    alt="img"
   style={{height:"20px", width:"20px"}}
  />Download Excel</CSVLink>
                                            </>
                                        ) : (
                                            <>
                                                <div type='button' style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "145px",
            height: "36px",
            border: "1px solid #ff5757",
            backgroundColor: "#fff",
            borderRadius: "20px",
            gap: "7px",
            color: "#ff5757",
            fontSize: "13px",
            fontWeight: "500",
            cursor: "pointer"
        }} disabled> <img
    src="/Download-PDF-32.png"
    alt="img"
   style={{height:"20px", width:"20px"}}
  />Download PDF</div>
                                                <div  style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "145px",
            height: "36px",
            border: "1px solid #24945c",
            backgroundColor: "#fff",
            borderRadius: "20px",
            gap: "7px",
            color: "#16834d",
            textDecoration: "none",
            fontSize: "13px",
            fontWeight: "500",
            cursor: "pointer"
        }} disabled><img
    src="/Download-Excel-32.png"
    alt="img"
   style={{height:"20px", width:"20px"}}
  /> Download Excel
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
    
    
                            {/* <div className="table-responsive" style={{ width: '96%', margin: '0 auto' }} ref={targetRef}>
                                <table className="project-table" style={{ backgroundColor: '#e8f7f3', width: '100%', borderCollapse: "collapse" }} ref={targetRef}>
                                    <thead>
                                        <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
                                            <th>File Name</th>
                                            <th>Total Count</th>
                                            <th>Total Amount</th>
                                        </tr>
                                        {summary.file && (
                                            <tr style={{ backgroundColor: "#c8e5fc", fontWeight: "600" }}>
                                                <td><a href={`${apiurl}/UploadedBillsFiles/${summary.file}`} target='_blank'>{summary.file}</a></td>
                                                <td>{summary.count}</td>
                                                <td>{summary.amount}</td>
                                            </tr>
                                        )}
    
                                        <tr style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: 'white' }}>
                                            <th>Sr.No.</th>
                                            <th>Unique_ID</th>
                                            <th>Account_HolderName</th>
                                            <th>Account_Number</th>
                                            <th>IFSC_CODE</th>
                                            <th>Refund_amount</th>
                                            <th>Payment_Mode</th>
                                            <th>Status</th>
                                            <th>StatusDesc</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
    
                                    <tbody>
                                        {paginatedData && paginatedData.length > 0 ? (
                                            paginatedData.map((e, index) => (
                                                <tr key={index}>
                                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                    <td>{e.Unique_ID}</td>
                                                    <td>{e.Account_HolderName}</td>
                                                    <td>{e.AccNumber}</td>
                                                    <td>{e.IFSC_CODE}</td>
                                                    <td>{e.refund_amount}</td>
                                                    <td>{e.Payment_Mode}</td>
                                                    <td>{e.status}</td>
                                                    <td>{e.statusDesc}</td>
                                                    <td>{e.Date?.split('.')[0].replace('T', ' ')}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="10" style={{ textAlign: 'center' }}>No data available in table</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
    
    
    
                                <div style={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#c8e5fc', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
                                    <div><p style={{ margin: '0px' }}>Showing {paginatedData.length} of {ecsdata.length} entries</p></div>
                                    <div >
                                        <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}> &laquo; </button>
                                       
                                        <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &lt; </button>
                                        {Array.from({ length: totalPages }, (_, index) => (
                                            <button key={index} onClick={() => handlePageChange(index + 1)} style={{ background: 'linear-gradient(to Right, #20ae8a, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', color: currentPage === index + 1 ? 'white' : 'black', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{index + 1}</button>
                                        ))}
                                        <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &gt; </button>
                                        <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}> &raquo;</button>
                                    </div>
                                </div>
                            </div> */}
    
                            <div className="col-12 tableDesign" style={{ overflowX: "auto" }} ref={targetRef}>
                                <table  style={{
            width: "max-content",
            minWidth: "100%",
            borderCollapse: "collapse",
            tableLayout: "auto"
        }}
     >
                                    <thead style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', backgroundImage: "none" }}>
                                        <tr style={{ color: "black", border: "none", height: "3rem", }}>
                                            <th>File Name</th>
                                            <th>Total Count</th>
                                            <th>Total Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {summary.file && (
                                            <tr style={{ backgroundColor: "#c8e5fc", fontWeight: "600", padding: "8px" }}>
                                                <td style={{ padding: "8px" }}>
                                                    <a href={`${apiurl}/UploadedBillsFiles/${summary.file}`} target="_blank">
                                                        {summary.file}
                                                    </a>
                                                </td>
                                                <td>{summary.count}</td>
                                                <td>{formatINR(summary.amount)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
    
                                {/* ✅ Scrollable Detail Table */}
                                <div className="col-12 tableDesign" style={{ overflowX: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", overflowX: "auto" }}>
                                        <thead style={{ background: 'linear-gradient(to Right, #3d8696, #2370a0, #4163a4, #575aa7, #754baa)', backgroundImage: "none" }}>
                                            <tr style={{ color: "black", border: "none", height: "3rem",backgroundColor:"#edf5fc" }}>
                                                <th style={{ minWidth: "70px" }}>Sr.No.</th>
                                                <th style={{ minWidth: "100px" }}>Unique ID</th>
                                                <th style={{ minWidth: "170px" }}>Account Holder Name</th>
                                                <th style={{ minWidth: "140px" }}>Account Number</th>
                                                <th style={{ minWidth: "120px" }}>IFSC CODE</th>
                                                <th style={{ minWidth: "110px" }}>Refund Amount</th>
                                                <th style={{ minWidth: "110px" }}> Payment Mode</th>
                                                <th style={{ minWidth: "100px" }}>Status</th>
                                                <th style={{ minWidth: "120px" }}>Status Desc</th>
                                                <th style={{ minWidth: "140px" }}>Date</th>
                                            </tr>
                                        </thead>
    
                                        <tbody>
                                            {(isPrinting || isPdfExporting ? ecsdata : paginatedData)?.length > 0 ? (
                                                (isPrinting || isPdfExporting ? ecsdata : paginatedData).map((e, index) => (
                                                    <tr key={index} style={{ background: "white" }}>
                                                        <td>{isPrinting || isPdfExporting ? index + 1 : (currentPage - 1) * itemsPerPage + index + 1}</td>
                                                        <td style={{ padding: "8px" }}>{e.Unique_ID}</td>
                                                        <td style={{ padding: "8px" }}>{e.Account_HolderName}</td>
                                                        <td style={{ padding: "8px" }}>{e.AccNumber}</td>
                                                        <td style={{ padding: "8px" }}>{e.IFSC_CODE}</td>
                                                        <td style={{ padding: "8px" }}>{formatINR(e.refund_amount)}</td>
                                                        <td style={{ padding: "8px" }}>{e.Payment_Mode}</td>
                                                        <td style={{ padding: "8px" }}>{e.status}</td>
                                                        <td style={{ padding: "8px" }}>{e.statusDesc}</td>
                                                        <td style={{ padding: "8px" }}>{e.Date?.split('.')[0].replace('T', ' ')}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="10" style={{ textAlign: 'center', background: "white", padding: "8px" }}>
                                                        No data available in table
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* Pagination */}
                           <div
        style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 10px",
            minHeight: "45px"
        }}
    >
        <p
            style={{
                margin: 0,
                fontSize: "13px",
                color: "#333"
            }}
        >
            Showing{" "}
            {ecsdata.length === 0
                ? "0 to 0"
                : `${(currentPage - 1) * itemsPerPage + 1} to ${Math.min(
                      currentPage * itemsPerPage,
                      ecsdata.length
                  )}`}{" "}
            of {ecsdata.length} entries
        </p>
     
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
                fontSize: "13px"
            }}
        >
            <span
                onClick={() =>
                    currentPage > 1 && handlePageChange(currentPage - 1)
                }
                style={{
                    cursor: currentPage > 1 ? "pointer" : "default",
                    color: currentPage > 1 ? "#333" : "#aaa"
                }}
            >
                &lt; Previous
            </span>
     
            {Array.from({ length: totalPages }, (_, index) => (
                <span
                    key={index}
                    onClick={() => handlePageChange(index + 1)}
                    style={{
                        cursor: "pointer",
                        color:
                            currentPage === index + 1
                                ? "#0B83C3"
                                : "#333",
                        fontWeight:
                            currentPage === index + 1 ? "600" : "400"
                    }}
                >
                    {index + 1}
                </span>
            ))}
     
            <span
                onClick={() =>
                    currentPage < totalPages &&
                    handlePageChange(currentPage + 1)
                }
                style={{
                    cursor:
                        currentPage < totalPages
                            ? "pointer"
                            : "default",
                    color:
                        currentPage < totalPages
                            ? "#333"
                            : "#aaa"
                }}
            >
                Next &gt;
            </span>
        </div>
    </div>
     
                        </div>
                    </div>
    
                    {/* Chart */}
                    <div  style={{
            width: "100%",
            height: "400px",
            backgroundColor: "white",
            padding: "25px 30px",
            borderRadius: "14px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)"
        }}>
                        <h3  style={{
                textAlign: "left",
                margin: "0 0 20px 0",
                fontSize: "18px",
                fontWeight: "600",
                color: "#222"
            }}
     >ECS Status Count</h3>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={chartData} margin={{ top: 10, right: 20, left: 10, bottom:20 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />
                                 <Bar
                dataKey="Count"
                radius={[30, 30, 30, 30]}
                barSize={60}
            >
                {chartData.map((entry, index) => (
                    <Cell
                        key={`cell-${index}`}
                        fill={
                            index === 0 ? "#74B9F2" :
                            index === 1 ? "#B7A3E2" :
                            index === 2 ? "#A5D8B0" :
                            index === 3 ? "#FFD875" :
                            "#FF8B84"
                        }
                    />
                ))}
            </Bar>
                                {/* <Legend /> */}
                                {/* <Bar/> */}
                            </BarChart>
                        </ResponsiveContainer>
                        <div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "22px",
            marginTop: "5px",
            fontSize: "12px"
        }}
    >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{
                width: "11px",
                height: "11px",
                backgroundColor: "#74B9F2",
                display: "inline-block"
            }} />
            <span>Generated</span>
        </div>
     
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{
                width: "11px",
                height: "11px",
                backgroundColor: "#B7A3E2",
                display: "inline-block"
            }} />
            <span>Awaited</span>
        </div>
     
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{
                width: "11px",
                height: "11px",
                backgroundColor: "#A5D8B0",
                display: "inline-block"
            }} />
            <span>Completed</span>
        </div>
     
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{
                width: "11px",
                height: "11px",
                backgroundColor: "#FFD875",
                display: "inline-block"
            }} />
            <span>Return</span>
        </div>
     
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span style={{
                width: "11px",
                height: "11px",
                backgroundColor: "#FF8B84",
                display: "inline-block"
            }} />
            <span>Failed</span>
        </div>
    </div>
     
                    </div>
    
                </div>
            </>
        )
}

export default ECSReport;